import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { apiClient } from '@services/api';
import Button from '@components/Button';
import Icon from '@material-ui/core/Icon';
import CircularProgress from '@material-ui/core/CircularProgress';

const FILTER_LABEL = {
  all:           'Todos os clientes',
  by_date_range: 'Por período de reserva',
  by_tour:       'Por passeio específico',
};

const BroadcastIndex = (props) => {
  const history = useHistory();
  const [broadcasts, setBroadcasts] = useState([]);
  const [loading, setLoading]       = useState(true);
  const [sending, setSending]       = useState(null);

  // Reenvio
  const [resendModal, setResendModal]     = useState(null); // { id, new_count, reminder_count }
  const [resending, setResending]         = useState(false);

  useEffect(() => { props.setShowMenu(false); }, []);

  const fetchBroadcasts = () => {
    setLoading(true);
    apiClient.httpInstance
      .get('/app-broadcasts')
      .then(res => setBroadcasts(res.data.data || []))
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchBroadcasts(); }, []);

  const handleSend = (id) => {
    if (!window.confirm('Enviar esta campanha agora para todos os destinatários? Esta ação não pode ser desfeita.')) return;
    setSending(id);
    apiClient.httpInstance
      .post(`/app-broadcasts/${id}/send`)
      .then(() => fetchBroadcasts())
      .catch(() => alert('Erro ao enviar campanha. Tente novamente.'))
      .finally(() => setSending(null));
  };

  const handleResendClick = (id) => {
    apiClient.httpInstance
      .get(`/app-broadcasts/${id}/resend-preview`)
      .then(res => setResendModal({ id, ...res.data }))
      .catch(() => alert('Erro ao carregar prévia de reenvio.'));
  };

  const handleResend = (target) => {
    setResending(true);
    apiClient.httpInstance
      .post(`/app-broadcasts/${resendModal.id}/resend`, { target })
      .then((res) => {
        const d = res.data;
        const total = (d.new_recipients || 0) + (d.reminder_recipients || 0);
        fetchBroadcasts();
        setResendModal(null);
        alert(`✅ Reenvio iniciado para ${total} cliente${total !== 1 ? 's' : ''}. As notificações serão entregues em instantes.`);
      })
      .catch((e) => {
        const msg = e?.response?.data?.message || 'Erro ao reenviar. Tente novamente.';
        alert(`❌ ${msg}`);
      })
      .finally(() => setResending(false));
  };

  return (
    <div className="px-7 pb-10">

      {/* Modal de reenvio */}
      {resendModal && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999,
        }}>
          <div style={{ background: '#fff', borderRadius: 14, padding: 28, maxWidth: 380, width: '90%' }}>
            <div style={{ fontWeight: 700, fontSize: 17, marginBottom: 6, color: '#1e293b' }}>Reenviar campanha</div>
            <p style={{ color: '#64748b', fontSize: 13, marginBottom: 18 }}>
              Escolha quem deve receber o reenvio:
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <button
                onClick={() => handleResend('new')}
                disabled={resending || resendModal.new_count === 0}
                style={{
                  textAlign: 'left', padding: '10px 14px', borderRadius: 9,
                  border: '1.5px solid #e2e8f0', background: resendModal.new_count === 0 ? '#f8fafc' : '#fff',
                  cursor: resendModal.new_count === 0 ? 'not-allowed' : 'pointer',
                  color: resendModal.new_count === 0 ? '#94a3b8' : '#1e293b',
                }}
              >
                <div style={{ fontWeight: 600, fontSize: 14 }}>
                  Só novos clientes
                  <span style={{ marginLeft: 6, background: '#eff6ff', color: '#3b82f6', borderRadius: 5, padding: '1px 7px', fontSize: 12 }}>
                    {resendModal.new_count}
                  </span>
                </div>
                <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>Clientes que se cadastraram após o envio original</div>
              </button>

              <button
                onClick={() => handleResend('reminder')}
                disabled={resending || resendModal.reminder_count === 0}
                style={{
                  textAlign: 'left', padding: '10px 14px', borderRadius: 9,
                  border: '1.5px solid #e2e8f0', background: resendModal.reminder_count === 0 ? '#f8fafc' : '#fff',
                  cursor: resendModal.reminder_count === 0 ? 'not-allowed' : 'pointer',
                  color: resendModal.reminder_count === 0 ? '#94a3b8' : '#1e293b',
                }}
              >
                <div style={{ fontWeight: 600, fontSize: 14 }}>
                  Lembrete geral
                  <span style={{ marginLeft: 6, background: '#fff7ed', color: '#f59e0b', borderRadius: 5, padding: '1px 7px', fontSize: 12 }}>
                    {resendModal.reminder_count}
                  </span>
                </div>
                <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>Todos os elegíveis pelos filtros atuais</div>
              </button>

              <button
                onClick={() => handleResend('both')}
                disabled={resending || (resendModal.new_count === 0 && resendModal.reminder_count === 0)}
                style={{
                  textAlign: 'left', padding: '10px 14px', borderRadius: 9,
                  border: '1.5px solid #e2e8f0',
                  background: (resendModal.new_count === 0 && resendModal.reminder_count === 0) ? '#f8fafc' : '#fff',
                  cursor: (resendModal.new_count === 0 && resendModal.reminder_count === 0) ? 'not-allowed' : 'pointer',
                  color: (resendModal.new_count === 0 && resendModal.reminder_count === 0) ? '#94a3b8' : '#1e293b',
                }}
              >
                <div style={{ fontWeight: 600, fontSize: 14 }}>
                  Ambos
                  <span style={{ marginLeft: 6, background: '#f0fdf4', color: '#22c55e', borderRadius: 5, padding: '1px 7px', fontSize: 12 }}>
                    {resendModal.new_count + resendModal.reminder_count}
                  </span>
                </div>
                <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>Novos + lembrete (sem duplicar)</div>
              </button>
            </div>

            <button
              onClick={() => setResendModal(null)}
              disabled={resending}
              style={{ marginTop: 18, width: '100%', padding: '8px 0', borderRadius: 8, border: '1px solid #e2e8f0', background: '#f8fafc', cursor: 'pointer', color: '#64748b', fontSize: 14 }}
            >
              Cancelar
            </button>
          </div>
        </div>
      )}
      {/* Header */}
      <div className="flex items-center justify-between mt-2 text-2xl" style={{ color: props.theme.color }}>
        <span>Broadcast FT App</span>
        <Button
          textcolor="#fff"
          padding="6px 15px"
          margintop="0px"
          width="180"
          onClick={() => history.push('/admin/broadcast-app/nova')}
          customcolor={props.theme.color}
        >
          <Icon className="mr-2" style={{ fontSize: 18 }}>campaign</Icon> Nova campanha
        </Button>
      </div>

      <p className="mt-2 text-sm" style={{ color: '#64748b' }}>
        Envie notificações push para clientes do FT App. Rascunhos são salvos e podem ser editados antes do envio.
      </p>

      {/* Lista */}
      <div className="mt-5 space-y-3">
        {loading ? (
          <div className="flex justify-center mt-16">
            <CircularProgress style={{ color: props.theme.color }} />
          </div>
        ) : broadcasts.length === 0 ? (
          <div className="bg-white rounded-xl p-10 text-center" style={{ color: '#64748b' }}>
            <Icon style={{ fontSize: 40, display: 'block', margin: '0 auto 8px' }}>campaign</Icon>
            Nenhuma campanha criada ainda.
          </div>
        ) : broadcasts.map(b => {
          const isDraft = b.status === 'draft';
          const statusColor = isDraft ? '#f59e0b' : '#22c55e';
          const statusLabel = isDraft ? 'Rascunho' : 'Enviado';
          return (
            <div
              key={b.id}
              className="bg-white rounded-xl p-4"
              style={{ border: '1px solid #e2e8f0' }}
            >
              <div className="flex items-start gap-3">
                {/* Ícone */}
                <div style={{
                  background: props.theme.color + '18',
                  borderRadius: 10,
                  width: 40, height: 40, minWidth: 40,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  <Icon style={{ color: props.theme.color, fontSize: 20 }}>
                    {isDraft ? 'edit_note' : 'check_circle'}
                  </Icon>
                </div>

                {/* Conteúdo */}
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-semibold text-blue text-base">{b.title}</span>
                    <span style={{
                      background: statusColor + '18', color: statusColor,
                      fontWeight: 600, fontSize: 11, borderRadius: 6, padding: '2px 8px',
                    }}>
                      {statusLabel}
                    </span>
                    {b.has_discount && (
                      <span style={{
                        background: '#8b5cf618', color: '#8b5cf6',
                        fontWeight: 600, fontSize: 11, borderRadius: 6, padding: '2px 8px',
                      }}>
                        🏷 {b.discount_percent}% desconto
                      </span>
                    )}
                  </div>

                  <p className="text-sm mt-1" style={{ color: '#475569', lineClamp: 2, WebkitLineClamp: 2, overflow: 'hidden', display: '-webkit-box', WebkitBoxOrient: 'vertical' }}>
                    {b.message}
                  </p>

                  <div className="flex flex-wrap gap-3 mt-2 text-xs" style={{ color: '#94a3b8' }}>
                    <span>👥 {FILTER_LABEL[b.filter_type] || b.filter_type}</span>
                    {b.sent_at && <span>📅 Enviado em {b.sent_at}</span>}
                    {b.recipients_count != null && !isDraft && (
                      <span>✉️ {b.recipients_count} destinatário{b.recipients_count !== 1 ? 's' : ''}</span>
                    )}
                    {b.creator_name && <span>Por {b.creator_name}</span>}
                  </div>
                </div>

                {/* Ações */}
                <div className="flex items-center gap-2 shrink-0">
                  {isDraft ? (
                    <>
                      <button
                        onClick={() => history.push(`/admin/broadcast-app/editar/${b.id}`)}
                        title="Editar rascunho"
                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#64748b', padding: 4 }}
                      >
                        <Icon>edit</Icon>
                      </button>
                      <Button
                        textcolor="#fff"
                        padding="4px 12px"
                        width="100"
                        margintop="0px"
                        customcolor={props.theme.color}
                        onClick={() => handleSend(b.id)}
                        disabled={sending === b.id}
                      >
                        {sending === b.id
                          ? <CircularProgress size={14} style={{ color: '#fff' }} />
                          : <><Icon style={{ fontSize: 14, marginRight: 4, verticalAlign: 'middle' }}>send</Icon>Enviar</>
                        }
                      </Button>
                    </>
                  ) : (
                    <button
                      onClick={() => handleResendClick(b.id)}
                      title="Reenviar campanha"
                      style={{ background: 'none', border: '1px solid #e2e8f0', borderRadius: 7, cursor: 'pointer', color: '#64748b', padding: '4px 10px', fontSize: 13, display: 'flex', alignItems: 'center', gap: 4 }}
                    >
                      <Icon style={{ fontSize: 16 }}>replay</Icon>
                      Reenviar
                    </button>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BroadcastIndex;
